<template>
  <div>
    <v-overlay opacity="0.8"
               :value="loading">
      <v-progress-circular color="kbGreen"
                           indeterminate
                           size="64">
      </v-progress-circular>
    </v-overlay>
    <v-row class="main-row"
           :style="{ top: menuLocation === 'toolbar' ? '0' : '150px', marginBottom: menuLocation === 'toolbar' ? '0' : '150px' }">
      <v-col cols="12"
             sm="6"
             md="4"
             lg="3"
             :key="info.name"
             v-for="info in mainInfo">
        <CardStatistics :info="info"/>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="3">
        <v-autocomplete clearable
                        @input="getStatistics"
                        :items="advisersFilter"
                        item-text="name"
                        item-value="userId"
                        label="Asesor"
                        v-model="selectedAdvisor">
        </v-autocomplete>
      </v-col>

      <v-col cols="3">
        <v-autocomplete clearable
                        @input="getStatistics"
                        label="Razón de finalización"
                        :items="chatSettings.finishOptions"
                        v-model="selectedEndReason">
        </v-autocomplete>
      </v-col>
    </v-row>

    <v-row>
      <FunnelGraph :selectedAdvisor="selectedAdvisor"
                   v-if="appUuid === '4xqa32nkgws7wib' || appUuid === '35zulkexkhv3u27d'">
      </FunnelGraph>

      <v-col cols="12">
        <v-data-table :headers="headers"
                      :items="advisers"
                      :items-per-page="5"
                      class="elevation-1">
          <template v-slot:item.imagen="{ item }">
            <v-avatar color="grey lighten-2" size="40px">
              <v-icon v-if="item.Name === 'nobody'">
                mdi-account-remove
              </v-icon>

              <v-icon v-else>
                {{item.Name === 'bot' ? 'mdi-robot' : 'mdi-face'}}
              </v-icon>
            </v-avatar>
          </template>

          <template v-slot:item.Name="{ item }">
            <!-- TODO: AGREGAR bot, nobody, waiting, noName a las traducciones -->
            {{item.Name ? $t(item.Name) : 'Sin nombre'}}
          </template>

          <template v-slot:item.AvgResponse="{ item }">
            {{formatTime(item.AvgResponse)}}
          </template>
        </v-data-table>
      </v-col>

      <ConversationsAttendedVsNotAttended/>

      <ConversationsPerChannel/>

      <WaitTime/>

      <ResponseTime/>

      <ConversationsAttended v-if="daysInterval >= 30"/>

      <ConversationsClassification/>

      <ProactivityCameToThem v-if="appUuid === '4xqalilk7bzu6iv'"/>

      <ServiceQualification v-if="appUuid === '4xqalilk7bzu6iv'"/>

      <BotMistakesPerDay v-if="appUuid === '4xqalilk7bzu6iv'"/>

    </v-row>
  </div>
</template>

<script>
import { EventBus } from '@/eventBus.js'
import { mapState, mapGetters } from 'vuex'
import CardStatistics from '@/pages/App/Conversations/Metrics/CardStatistics.vue'
import ConversationsAttended from '@/pages/App/Conversations/Metrics/ConversationsAttended.vue'
import ConversationsAttendedVsNotAttended from '@/pages/App/Conversations/Metrics/ConversationsAttendedVsNotAttended.vue'
import ConversationsPerChannel from '@/pages/App/Conversations/Metrics/ConversationsPerChannel.vue'
import FunnelGraph from '@/pages/App/Conversations/Metrics/FunnelGraph.vue'
import ResponseTime from '@/pages/App/Conversations/Metrics/ResponseTime.vue'
import WaitTime from '@/pages/App/Conversations/Metrics/WaitTime.vue'
import ConversationsClassification from '@/pages/App/Conversations/Metrics/ConversationsClassification.vue'
import ProactivityCameToThem from '@/pages/App/Conversations/Metrics/ProativityCameToThem.vue'
import BotMistakesPerDay from '@/pages/App/Conversations/Metrics/BotMistakesPerDay.vue'
import ServiceQualification from '@/pages/App/Conversations/Metrics/ServiceQualification.vue'

export default {
  components: {
    BotMistakesPerDay,
    CardStatistics,
    ConversationsAttended,
    ConversationsAttendedVsNotAttended,
    ConversationsClassification,
    ConversationsPerChannel,
    FunnelGraph,
    ProactivityCameToThem,
    ResponseTime,
    ServiceQualification,
    WaitTime
  },
  created () {
    EventBus.$emit('toggleSideBar', false)
    this.getAdvisers()
    this.getStatistics()
    this.getAppInfo()
  },
  computed: {
    ...mapGetters(['chatSettings']),
    ...mapState({
      menuLocation: state => state.graphicAspect.menuLocation,
      statistics: state => state.conversations.statistics
    }),
    ...mapGetters([
      'datesRange',
      'appUuid'
    ]),
    advisers () {
      if (!this.statistics) return []

      return this.statistics.Operators
    },
    daysInterval () {
      if (this.datesRange.length < 2) return 1

      const a = this.$moment(this.datesRange[0])
      const b = this.$moment(this.datesRange[1])

      return b.diff(a, 'days') + 1
    },
    mainInfo () {
      if (!this.statistics) return []

      const attended = this.statistics.Type.find(item => {
        return item.Name === 'Attended'
      })

      const notAttended = this.statistics.Type.find(item => {
        return item.Name === 'NotAttended'
      })

      return [
        {
          name: this.$t('general.totalConversations'),
          value: this.statistics.Total[0] ? this.statistics.Total[0].Count : 0,
          percetage: '+0%',
          date: this.$t('general.lastMonth'),
          type: 'increase'
        },
        {
          name: this.$t('general.attendedConversations'),
          value: attended ? attended.Count : 0,
          percetage: '+0%',
          date: this.$t('general.lastMonth'),
          type: 'increase'
        },
        {
          name: this.$t('general.noAttendedConversations'),
          value: notAttended ? notAttended.Count : 0,
          percetage: '+0%',
          date: this.$t('general.lastMonth'),
          type: 'increase'
        }
      ]
    },
    headers () {
      return [
        { text: '', value: 'imagen' },
        { text: this.$t('general.host'), value: 'Name' },
        { text: this.$t('general.conversations'), value: 'Conversations', align: 'center' },
        { text: this.$t('general.attended'), value: 'Attended', align: 'center' },
        { text: this.$t('general.noAttended'), value: 'NotAttended', align: 'center' },
        { text: '%', value: 'porcentaje' },
        { text: this.$t('general.responseTime'), value: 'AvgResponse', align: 'center' }
      ]
    }
  },
  data: () => ({
    advisersFilter: [],
    loading: false,
    selectedAdvisor: null,
    selectedEndReason: null
  }),
  methods: {
    allowedDates () {
      return {
        min: this.$moment().subtract(60, 'days').format('YYYY-MM-DD'),
        max: this.$moment().format('YYYY-MM-DD')
      }
    },
    formatTime (time) {
      let seconds = Math.floor((time / 1000) % 60)
      let minutes = Math.floor((time / (1000 * 60)) % 60)
      let hours = Math.floor((time / (1000 * 60 * 60)) % 24)

      hours = (hours < 10) ? '0' + hours : hours
      minutes = (minutes < 10) ? '0' + minutes : minutes
      seconds = (seconds < 10) ? '0' + seconds : seconds

      return hours + 'h ' + minutes + 'm ' + seconds + 's'
    },
    async getAdvisers () {
      const response = await this.$store.dispatch('getAdvisers')

      if (response.success) {
        this.advisersFilter = response.advisers
      }
    },
    async getAppInfo () {
      const appInfo = await this.$store.dispatch('getAppInfo', { getStatistics: false })
      this.$store.commit('SET_APP_INFO', appInfo)
    },
    async getStatistics () {
      try {
        this.loading = true

        const data = {
          advisorId: this.selectedAdvisor,
          endReason: this.selectedEndReason,
          ...this.datesRange
        }

        const statistics = await this.$store.dispatch('getStatistics', data)
        this.$store.commit('SET_CONVERSATIONS_STATISTICS', statistics)

        const funnelParams = {
          endReason: this.selectedEndReason,
          ...this.datesRange
        }

        const funnelData = await this.$store.dispatch('getFunnelData', funnelParams)
        this.$store.commit('SET_FUNNEL_DATA', funnelData.funnel)

        this.loading = false
      } catch (e) {
        this.loading = false
      }
    }
  },
  watch: {
    datesRange: {
      deep: true,
      handler () {
        this.getStatistics()
      }
    }
  }
}
</script>

<style>
  .main-row {
    justify-content: space-between;
    position: relative;
    margin-left: 0;
    margin-right: 0;
    width: 100%;
    z-index: 1;
  }
</style>
